import { ASSET_TYPE_VALUES, AssetType } from '../../../shared/models/Asset';
import React, { useEffect } from 'react';

import AssetService from '../../../shared/services/AssetService';
import AudioIcon from '../../images/file-icon-audio.svg';
import Button from '@mui/material/Button';
import ChangeFile from '../../../shared/components/ChangeFile';
import { FileComponent } from '../../models/LessonComponent';
import FileDownloadComponent from './FileDownloadComponent';
import FileIcon from '../../images/file-icon-file.svg';
import Grid from '@mui/material/Unstable_Grid2';
import ImageIcon from '../../images/file-icon-image.svg';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import VideoIcon from '../../images/file-icon-video.svg';
import { fileSize } from 'humanize-plus';
import useAssets from '../../../shared/hooks/useAssets';
import { useLessonContext } from '../../models/LessonContext';
import { useTheme } from '@mui/material';

interface FileProps {
  component: FileComponent;
}

const assetTypes: AssetType[] = ASSET_TYPE_VALUES.map((a) => a);

export function File(props: FileProps) {
  const muiTheme = useTheme();
  const primaryColor = muiTheme.palette.primary.main;
  const assetkey = props.component.settings.assetkey;
  const { mode } = useLessonContext();
  const { getAssetMetadata, assetMetadata } = useAssets(
    assetTypes,
    'author',
    false /* no need to load assets */
  );
  const { filename, size } = assetMetadata || {};
  const contentType = assetMetadata?.contentType;
  const assetType: AssetType = AssetService.getAssetTypeFromMime(contentType);

  const AssetIcon = () => {
    switch (assetType) {
      case 'audio':
        return <img src={AudioIcon} />;
      case 'image':
        return <img src={ImageIcon} />;
      case 'video':
        return <img src={VideoIcon} />;
      default:
        return <img src={FileIcon} />;
    }
  };

  useEffect(() => {
    if (props.component.settings.assetkey) {
      getAssetMetadata('author_assets', props.component.settings.assetkey);
    }
  }, [props.component.settings.assetkey]);

  const url = AssetService.getAssetUrl(props.component.settings.assetkey);
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Grid style={{ borderRadius: '50%', backgroundColor: primaryColor }}>
        <AssetIcon />
      </Grid>
      {url ? (
        <>
          <Grid>
            <Typography variant="caption">
              {unescape(filename || '')}
            </Typography>
          </Grid>
          {size && (
            <Grid>
              <Typography variant="caption">{fileSize(size)}</Typography>
            </Grid>
          )}
        </>
      ) : (
        <Grid>
          <Typography variant="caption">No file chosen</Typography>
        </Grid>
      )}
      {mode === 'edit' && (
        <ChangeFile
          component={props.component}
          assetkey={assetkey}
          assetTypes={assetTypes}
          fileType="Select File"
          style={{ position: 'unset' }}
        />
      )}
      <FileDownloadComponent url={url} filename={filename} />
    </Grid>
  );
}
